export default "__VITE_ASSET__DRwYLOCo__"